import { render, staticRenderFns } from "./ParchaseCompleted.vue?vue&type=template&id=17fc4cc4&scoped=true&"
import script from "./ParchaseCompleted.vue?vue&type=script&lang=js&"
export * from "./ParchaseCompleted.vue?vue&type=script&lang=js&"
import style0 from "./ParchaseCompleted.vue?vue&type=style&index=0&id=17fc4cc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17fc4cc4",
  null
  
)

export default component.exports